<template>
    <v-navigation-drawer
        v-model="drawer"
        class="secondary darken-1"
        style="font-family: Roboto, sans-serif; background-color: #e4e2e2 !important;"
        fixed
        temporary
        disable-resize-watcher
    >
        <div class="menu-bg"></div>
        <v-list class="pa-1">
            <v-list-tile avatar tag="div">

                <kimsa-avatar size="40px" :imageUrl="currentUser && currentUser.avatar"></kimsa-avatar>

                <v-list-tile-content>
                    <v-list-tile-title>{{ currentUser && currentUser.first_name || 'Usuario' }}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon @click="drawer = !drawer">{{ drawer ? 'fa-arrow-left' : 'fa-arrow-right' }}</v-icon>
                </v-list-tile-action>

            </v-list-tile>
        </v-list>

        <v-list class="pt-0" dense subheader>
            <v-subheader>General</v-subheader>
            <v-divider light></v-divider>

            <template v-for="(item, i) in userItems">
                <v-list-tile :to="item.link" :key="i+'general'" @click="goTo(item.link)">
                    <v-list-tile-avatar>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </template>

            <v-subheader v-if="providerItems.length > 0">Proveedor</v-subheader>
            <v-divider light></v-divider>

            <template v-for="(item, i) in providerItems">

                <v-list-group
                    class="menu-group"
                    :prepend-icon="item.icon"
                    v-if="item.children"
                    :value="needExpandMenu(item.children)"
                >
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile>
                    </template>

                    <v-list-tile
                        v-for="(child, j) in item.children"
                        @click="drawer=false"
                        :to="child.link"
                        :key="`${i}-${j}`"
                        class="pl-2"
                    >
                        <v-list-tile-avatar>
                            <v-icon :color="activeChildrenIcon(child.link.name)">{{ child.icon }}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ child.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>

                </v-list-group>

                <v-list-tile v-else :to="item.link" :key="i+'proveedor'" @click="goTo(item.link)">
                    <v-list-tile-avatar>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </template>

            <template v-if="superItems.length > 0">
                <v-subheader>{{ appName }} Admin</v-subheader>
                <v-divider light></v-divider>

                <template v-for="(item, i) in superItems">

                    <v-list-group
                        class="menu-group"
                        :prepend-icon="item.icon"
                        v-if="item.children"
                    >
                        <template v-slot:activator>
                            <v-list-tile>
                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                            </v-list-tile>
                        </template>

                        <v-list-tile
                            v-for="(child, j) in item.children"
                            @click="drawer=false"
                            :to="child.link"
                            :key="`${i}-${j}`"
                            class="pl-2"
                        >
                            <v-list-tile-avatar>
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ child.title }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>

                    </v-list-group>

                    <v-list-tile v-else :to="item.link" :key="i+'admin'" @click="goTo(item.link)">
                        <v-list-tile-avatar>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </template>


            <v-divider light></v-divider>

            <v-list-tile @click="setLogoutVisibility">
                <v-list-tile-action>
                    <v-icon>fas fa-sign-out-alt</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Salir</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import KimsaAvatar from '@/components/common/KimsaAvatar'
import {hasAccess} from '@/utils/Auth'

export default {
    props: ['show', 'onDrawerChange'],
    components: {KimsaAvatar},
    data() {
        return {
            drawer: this.show,
            mini: false,
            right: null,
        }
    },
    computed: {
        ...mapState(['currentUser', 'currentProvider']),
        user() {
            const vm = this
            let items = [
                {title: 'Dashboard', icon: 'home', link: {name: 'panel.dashboard'}},
                {title: 'Mis Datos', icon: 'fa-user', link: {name: 'panel.user.info'}}
            ]

            if (vm.currentUser && !vm.currentProvider && vm.isOnBoardingDone) {
                items = [
                    ...items,
                    {title: 'Presupuestos', icon: 'fa-calculator', link: {name: 'panel.user.quotation_requests'}},
                    {title: 'Promociones', icon: 'fas fa-piggy-bank', link: {name: 'panel.user.special_sales'}},
                    {title: 'Agenda', icon: 'fa-calendar-alt', link: {name: 'panel.user.appointments'}}
                ]
            }

            return items

        },
        provider() {
            const vm = this
            return [
                // { title: 'Datos Proveedor', icon: 'fa-user', link: {name: 'panel.provider.info'} },
                {title: 'Agendas', icon: 'fas fa-list-alt', link: {name: 'panel.provider.schedule'}},
                {title: 'Citas', icon: 'fas fa-user-clock', link: {name: 'panel.provider.appointments'}},
                {title: 'Mis agendas', icon: 'fas fa-list-alt', link: {name: 'panel.provider.my_schedules'}},
                {title: `Atención`, icon: 'fas fa-door-open', link: {name: 'panel.provider.specialist_daily_schedule'}},
                {title: vm.clientPlural, icon: 'fa-user-tag', link: {name: 'panel.provider.clients'}},
                {
                    title: 'Configuraciones', icon: 'fas fa-cog', children: [
                        {title: 'Sucursales', icon: 'fa-building', link: {name: 'panel.provider.branches'}},
                        {title: 'Servicios', icon: 'fa-briefcase', link: {name: 'panel.provider.services'}},
                        {title: 'Miembros', icon: 'fas fa-users', link: {name: 'panel.provider.members'}},
                        {title: 'Galería', icon: 'fas fa-images', link: {name: 'panel.provider.gallery'}},
                        {title: 'Mas', icon: 'fas fa-cogs', link: {name: 'panel.provider.settings'}},
                    ]
                },
                {title: 'Presupuestos', icon: 'fa-calculator', link: {name: 'panel.provider.quotations'}},
                {title: 'Solicitudes', icon: 'fa-ticket-alt', link: {name: 'panel.provider.quotation_requests'}},


            ]
        },
        superAdmin() {
            return [
                {title: 'Planes', icon: 'fas fa-receipt', link: {name: 'panel.super.plans'}},
                {title: 'Cupones', icon: 'fas fa-ticket-alt', link: {name: 'panel.super.coupons'}},
                {title: 'Cuentas', icon: 'fas fa-user-circle', link: {name: 'panel.super.accounts'}},
            ]
        },
        providerItems() {
            var vm = this
            var providerMap = vm.provider.map(item => {

                if (item.children) {
                    item.children = item.children.filter(subItem => {
                        return hasAccess(subItem.link.name)
                    })
                    if (item.children.length === 0) return null
                }

                return item

            })

            return providerMap.filter(item => {

                if (item === null) return false

                if (!item.children) {
                    return hasAccess(item.link.name)
                }

                return true
            })
        },
        userItems() {
            var vm = this
            return vm.user.filter(item => vm.hasAccess(item.link.name))
        },
        superItems() {
            var vm = this
            return vm.superAdmin.filter(item => vm.hasAccess(item.link.name))
        },
    },
    watch: {
        currentUser(val) {
            this.drawer = Boolean(this.drawer)
        },
        show(val) {
            this.drawer = val
            if (val) {
                //this.blurWrapper()
            } else {
                //this.unBlurWrapper()
            }
        },
        drawer(val) {
            if (typeof this.onDrawerChange == 'function') {
                this.onDrawerChange(val)
            }
        }
    },
    methods: {
        ...mapMutations(['setLogoutVisibility', 'blurWrapper']),
        goTo(route) {
            const vm = this
            vm.$router.push(route)
            vm.drawer = false
        },
        hasAccess,
        activeChildrenIcon(link) {
            return this.$route.name === link ? 'primary' : ''
        },
        needExpandMenu(routes) {
            return routes.some(route => route.link.name === this.$route.name)
        }
    }
}
</script>

<style scoped>

.menu-bg {
    position: fixed;
    background-size: cover;
    opacity: .3;
    background-position: left;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.menu-group {
    padding-left: 10px;
}

>>> .menu-group .v-list__tile:first-child {
    padding-left: 5px !important;
}


</style>